// React
import React from 'react';

// Styles
import styles from './LoadingIndicator.module.scss';

// Third party
import PropTypes from 'prop-types';

// Material UI
import { Backdrop, CircularProgress } from '@material-ui/core';

// This component
export default function LoadingIndicator({ active }) {
  // JSX
  return (
    <Backdrop className={styles.wrapper} open={active}>
      <CircularProgress />
    </Backdrop>
  );
}

// Properties
LoadingIndicator.propTypes = {
  active: PropTypes.bool.isRequired
};
